import angular from 'angular'

import movementAsk from './services/ask.service'
import movementData from './services/data.service'
import movementFormat from './services/format.service'
import movementGo from './services/go.service'
import movementLocal from './services/local.service'
import movementMetadata from './services/metadata.service'
import movementNew from './services/new.service'
import movementRequest from './services/request.service'
import movementResource from './services/resource.service'
import movement from './services/movement.service'

import myMovementForm from './directives/forms/myMovementForm'
import myMovementSearchForm from './directives/forms/myMovementSearchForm'

import movementIcons from './resources/icons.resource'
import movementFields from './resources/fields.resource'
import movementLabels from './resources/labels.resource'

const name = 'movement'
angular.module(name, [])
  // ===== SERVICES ===== //
  .factory('movementAsk', movementAsk)
  .factory('movementData', movementData)
  .factory('movementFormat', movementFormat)
  .factory('movementGo', movementGo)
  .factory('movementLocal', movementLocal)
  .factory('movementMetadata', movementMetadata)
  .factory('movementNew', movementNew)
  .factory('movementRequest', movementRequest)
  .factory('movementResource', movementResource)
  .factory('$$movement', movement)
  // ===== DIRECTIVES ===== //
  .directive('myMovementForm', myMovementForm)
  .directive('myMovementSearchForm', myMovementSearchForm)
  // ===== RESOURCES ===== //
  .factory('movementIcons', movementIcons)
  .factory('movementFields', movementFields)
  .factory('movementLabels', movementLabels)

export default 'movement'



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/movement.module.js